function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const TrustedIcon = _ref => {
  let {
    size = 16,
    bg = 'currentColor',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.479 6.122l-11-6a1.003 1.003 0 0 0-.958 0l-11 6A1 1 0 0 0 4 7v8c0 4.4 1.135 7.957 3.469 10.875 1.824 2.28 4.317 4.136 8.084 6.02a1.006 1.006 0 0 0 .894 0c3.767-1.883 6.26-3.74 8.084-6.02C26.865 22.957 28 19.4 28 15V7a1 1 0 0 0-.521-.878zM13 22.591L7.409 17 9 15.409l4 4 10-10L24.591 11 13 22.591z"
  }));
};
export default TrustedIcon;